import { createContext, useContext } from 'react';
import { IBulkUpdateChannelGroupConfig } from '~/src/dash/views/bulk-update-channel-groups/config';

interface IBulkUpdateChannelGroupContext {
  cfg: IBulkUpdateChannelGroupConfig;
}
export const BulkUpdateChannelGroupContext = createContext({} as IBulkUpdateChannelGroupContext);
export const useBulkUpdateChannelGroupStore = (): IBulkUpdateChannelGroupContext =>
  useContext(BulkUpdateChannelGroupContext);
